<button type="button" [attr.aria-expanded]="isOpened" #popoverParent class="ap-popover" data-bb="popover-trigger" (click)="onToggle()">
    <ng-content select="span[ap-popover-parent]"></ng-content>
</button>

@if (isOpened) {
    <div
        id="{{ id }}"
        #content
        class="ap-popover__content"
        [class.ap-popover__content--left]="position() === 'left' || position() === 'auto'"
        [class.ap-popover__content--right]="position() === 'right'"
        [class.ap-popover__content--alignment-left]="contentAlignment() === 'left'"
        [class.ap-popover__content--alignment-right]="contentAlignment() === 'right'"
        [style.maxWidth]="maxWidth + 'px'"
        data-bb="popover-content"
    >
        <div #innerContent>
            <ng-content select="[ap-popover-content]"></ng-content>
        </div>
    </div>
}
